export enum InformationMessageTrigger {
    SCHEDULED_EXPORT_DISPO_MONTHLY,
    SCHEDULED_EXPORT_GNL_DAILY,
    SCHEDULED_EXPORT_REQUEST,
    STATIONS_STATE_BECAME_AVAILABLE,
    STATIONS_STATE_BECAME_UNAVAILABLE,
    STATION_OPENED,
    STATION_CLOSED,
    STATION_UNLOADING,
    STATION_LOADING,
    AUTH_SUPPORT_BLOCKED,
    AUTH_SUPPORT_ACTIVATED,
    TICKET_CREATION,
    TICKET_ESCALATION,
    TICKET_ESTIMATED,
    TICKET_CLOSED,
    TRANSACTION_REPORT_CREATED,
    USER_CREATION,
    USER_FORGOT_PASSWORD,
    USER_NEED_REGISTER,
    USER_RESET_PASSWORD,
    USER_PERMANENT_DELETION,
    EXPORT_REQUEST_DONE,
    EXPORT_REQUEST_ERROR,
    EXPORT_REQUEST_SUPPORT,
    EXTERNAL_API_AVAILABLE,
    EXTERNAL_API_UNAVAILABLE,
    STATION_THUNDERSTORM,
    EXPORT_REQUEST_DONE_DOWNLOAD_LINK,
    ONBOARDING_INVITATION,
    TAG_THRESHOLD_EXCEEDED_HIGH,
    TAG_THRESHOLD_EXCEEDED_LOW,
    TAG_THRESHOLD_EXCEEDED_GOOD,
}
